<template>
    <div class="py-32 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div class="flex flex-col gap-3">
            <Button text="Sign up Now" variant="primary" size="md" />
            <Button text="Sign up Now" variant="secondary" size="md" />
            <Button text="Sign up Now" variant="accent" size="md" />

            <Button text="Sign up Now" variant="primary" hasArrow size="sm" />
            <Button text="Sign up Now" variant="secondary" hasArrow size="md" />
            <Button text="Sign up Now" variant="accent" hasArrow size="lg"/>

            <Button text="Sign up Now" variant="primary" size="sm" />
            <Button text="Sign up Now" variant="secondary" size="md" />
            <Button text="Sign up Now" variant="accent" size="lg"/>
        </div>

    </div>

</template>

<script setup>

import Button from '../components/Buttons/Button.vue'

</script>